import { ITracking } from '.';
import { isForProd, MIXPANEL_TOKEN } from '../api/constants';
import { cachedRouteParams } from '../App';
import { getDoc } from '../store/idbHandler';
import { MyProfileResponse } from '../api/fetchMyProfile';

export enum AptActivityType {
    CREATED = 'CREATED',
    VISIT_STARTED = 'VISIT_STARTED',
    VISIT_ENDED = 'VISIT_ENDED',
    VISIT_PARKED = 'VISIT_PARKED',
    VISIT_CANCELLED = 'VISIT_CANCELLED',
    VISIT_RESCHEDULED = 'VISIT_RESCHEDULED',
    VISIT_CHECKED_IN = 'VISIT_CHECKED_IN',
    FOLLOWUP_CHECKED_IN = 'FOLLOWUP_CHECKED_IN',
    MARKED_NOSHOW = 'MARKED_NOSHOW',
    MARKED_ABORTED = 'MARKED_ABORTED',
    MARKED_PARKABLE = 'MARKED_PARKABLE',
    MSG_SA = 'MSG_SA',
    APT_REMINDER_SENT = 'APT_REMINDER_SENT',
    VISIT_ARCHIVED = 'VISIT_ARCHIVED',
    APT_SYNC = 'APT_SYNC',
    REQ_CB = 'REQ_CB',
    SA_UPDATED = 'SA_UPDATED',
    APT_MUTLI_TAG = 'APT_MUTLI_TAG',
    APT_TAG_ADDED = 'APT_TAG_ADDED',
    APT_TAG_DELETED = 'APT_TAG_DELETED',
    APT_PAYMENT_UPDATED = 'APT_PAYMENT_UPDATED',
    PREPAY_FAILED = 'PREPAY_FAILED',
    TELE_STATUS = 'TELE_STATUS',
    FOLLOWUP_DATE_ADDED = 'FOLLOWUP_DATE_ADDED',
    FOLLOWUP_MESSAGE_UPDATE = 'FOLLOWUP_MESSAGE_UPDATE',
    FOLLOWUP_REMINDER_SENT = 'FOLLOWUP_REMINDER_SENT',
    RESCHEDULE_CREATED = 'RESCHEDULE_CREATED',
    REQUESTED_APT_CHECKED_IN = 'REQUESTED_APT_CHECKED_IN',
    RECEIPT_CREATED = 'RECEIPT_CREATED',
    RECEIPT_UPDATED = 'RECEIPT_UPDATED',
    RECEIPT_DELETED = 'RECEIPT_DELETED',
    ASSIGN_DOCTOR = 'ASSIGN_DOCTOR',
    SUBMIT_CUSTOM_FIELD = 'SUBMIT_CUSTOM_FIELD',
    SUBMIT_FIELD = 'SUBMIT_FIELD',
}

export enum Actor {
    DOCTOR = 'DOCTOR',
    STAFF = 'STAFF',
    SYSTEM = 'SYSTEM',
    PATIENT = 'PATIENT',
}

const BLACK_LISTED_EVENTS: { [k: string]: number } = {
    AS_SEARCH: 1,
    PUSH_DIFF: 1,
    UPDATE_COMPLIMENTARY_DRUG: 1,
    UPDATE_DRUG_INTERACTIONS: 1,
    UPDATE_RELATED_SYM_DIA: 1,
    UPDATE_SUGGESTED_DRUGS_LAB_TESTS: 1,
    UPDATE_SYM_DIA_PROPERTIES: 1,
    SANITIZE_FINAL_PRESCRIPTION: 1,
};

export const Mixpanel: ITracking = {
    initTracking() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        mixpanel?.init(MIXPANEL_TOKEN, { debug: !isForProd, ignore_dnt: true });
    },

    setTrackingIdentify(profile: MyProfileResponse) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        mixpanel?.identify(profile.user.uuid);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        mixpanel?.people.set(
            'User Name',
            [profile.user.fn, profile.user.ln].filter(Boolean).join(' '),
        );
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        mixpanel?.people.set('Role', profile.user['is-d'] ? 'Doctor' : 'Staff');
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        mixpanel?.people.set('OID', profile.user.oid);

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        mixpanel?.register({
            OID: profile.user.oid,
            Docid: profile.user['doc-id'],
            UUID: profile.user.uuid,
            'User Name': [profile.user.fn, profile.user.ln].filter(Boolean).join(' '),
            BID: profile.user['b-id'] || profile.business?.id,
            Flavour: 'dw',
            Paid: profile.doctor?.profile?.professional?.saas_detail?.status || false,
        });
    },

    resetTracking() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        mixpanel?.reset();
    },

    track(name, params) {
        if (BLACK_LISTED_EVENTS[name]) {
            return;
        }

        const doc = getDoc();

        const FLAVOUR = 'dw';
        const docid = doc?._id ?? '';
        const doc_name = `${doc?.profile.personal.name.f ?? ''} ${
            doc?.profile.personal.name.l ?? ''
        }`;
        const category = doc?.profile.professional.category?.join(', ');
        const role = doc?.loginmeta?.role;
        const user_oid = doc?.loginmeta?.userid ?? '';

        const eventProperties = {
            ...cachedRouteParams,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            APP_VERSION: APP_VERSION,
            // FLAVOUR,
            // docid,
            doc_name,
            category,
            // user_oid,
            // role,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            'Clinic Id': cachedRouteParams['cId'],
            cId: undefined,
        };

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        mixpanel?.track(name, params ? { ...eventProperties, ...params } : eventProperties);
    },

    timeTrackStart(name: string) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        mixpanel?.time_event(name);
    },
};
